import { render, staticRenderFns } from "./bolt_dine_in_location_modal.vue?vue&type=template&id=b55ff1d6&scoped=true&"
import script from "./bolt_dine_in_location_modal.vue?vue&type=script&lang=js&"
export * from "./bolt_dine_in_location_modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b55ff1d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b55ff1d6')) {
      api.createRecord('b55ff1d6', component.options)
    } else {
      api.reload('b55ff1d6', component.options)
    }
    module.hot.accept("./bolt_dine_in_location_modal.vue?vue&type=template&id=b55ff1d6&scoped=true&", function () {
      api.rerender('b55ff1d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/bolt_dine/location/bolt_dine_in_location_modal.vue"
export default component.exports